<template>
	<div class="">
		<div class="donation-payment-cycle" v-if="show_recurring && strings">
				<a
				href="#"
				:class="!store.recurring && 'active'"
				@click.prevent="store.recurring = false"
				>{{ strings.one_time }}</a
			>
			<a
				href="#"
				:class="store.recurring && 'active'"
				@click.prevent="store.recurring = true"
				>{{ strings.recurring }}</a
			>

		
		</div>
		<div class="position-relative mt-60">
			<div class="donation-payment-method">
				<template
					v-for="(gateway, gateway_id) in gateways"
				>
					<a
					 
						@click.prevent="setValue('payment_method', gateway.id)"
						:class="[
							'mb-3',
							gateway.id === store.payment_method && 'active'
						]"
						title=""
						href="#"
						>
              <span><img :src="gateway.icon" alt=""></span>
              {{ gateway.title ? gateway.title : gateway.name }}
            </a
					>
				</template>
			</div>
			<slot name="gateway_data"></slot>
		</div>
		<slot></slot>
	</div>
</template>

<script setup lang="ts">
import { useDonationFormsStore } from '../../store';

const store = useDonationFormsStore();
const props = defineProps(["gateways", "show_recurring", "strings"]);

const setValue = (key, val) => {
	store[key] = val;
};
const getBack = () => {
};


</script>
